<template>
  <div>
    <ul class="gift_list">
      <li v-for="(data, idx) in giftData" v-bind:key="idx">
        <div class="point" v-if="data.mingle_count_title"><span class="stxt">{{ data.mingle_count_title }}</span></div>
        <div class="point" v-else>{{data.mingle_count}}{{unit}}</div>
        <img class="gift_img" :src="'https://tg-s3.tranggle.com/mingle/image/mingle/'+data.mingle_gift_image" alt="gift">
        <span>{{data.mingle_gift_title}}
          <b class="limit_gift"
            v-if="data.mingle_gift_com_yn === 'Y'">({{cntCheck(data)}}/{{data.mingle_gift_com_cnt}})</b>
        </span>
        <div
          v-if="data.mingle_gift_receive === 'S' || ((data.user_gift_send_date !== null || data.user_gift_request_date !== null) && data.mingle_gift_request_date !== '' && data.mingle_gift_receive !== 'Y')"
          class="gift_complete">
          완료
        </div>
        <div
          v-else-if="data.mingle_gift_receive === 'E' || giftEndState(data) || (okhwaYn === 'N' && data.mingle_no === '43' && data.mingle_gift_add_point) || (parseInt(data.user_com_cnt) >= parseInt(data.mingle_gift_com_cnt) && data.mingle_gift_com_yn === 'Y')"
          class="gift_complete">
          마감
        </div>
        <div v-else class="gift_icon" :class="dotOn(data)" @click="giftReceive(data)">
          <img :src="giftOn(data)" alt="gift">
          <div class="dot"></div>
        </div>
        <div class="line"></div>
        <div class="giftDday"
          v-if="(dotOn(data) === 'on' || dotOn(data) === 'end') && data.mingle_gift_end_date !== null && data.user_gift_send_date === null && data.user_gift_request_date === null">
          {{dDay(data)}}</div>
      </li>
    </ul>
    <!-- 블랙리스트 팝업 -->
    <PopupBlackList v-if="blackListPop" />
    <!-- 별점유도 팝업 -->
    <PopupStarPoint v-if="starPointPop" />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import PopupBlackList from '@/components/popup/PopupBlackList.vue'
import PopupStarPoint from '@/components/popup/PopupStarPoint.vue'
export default {
  name: 'GiftList',
  components: {
    PopupBlackList,
    PopupStarPoint
  },
  data () {
    return {
      unit: '',
      load: false,
      blackList: [ // 머니콘 부정 발급자들 임시 막기
        '010-2245-1939',
        '010-2256-1939',
        '010-2280-1980',
        '010-2614-4716',
        '010-2621-8909',
        '010-2859-9711',
        '010-3015-3845',
        '010-3029-3652',
        '010-3153-4640',
        '010-3166-8195',
        '010-3517-0458',
        '010-3600-8480',
        '010-3652-6803',
        '010-3655-6395',
        '010-3786-1939',
        '010-3926-9211',
        '010-3930-6944',
        '010-4167-3574',
        '010-4286-6311',
        '010-4532-7654',
        '010-4759-5120',
        '010-5063-8475',
        '010-5106-7717',
        '010-5373-2542',
        '010-5610-4517',
        '010-5626-1292',
        '010-5653-6163',
        '010-6476-3576',
        '010-6490-5031',
        '010-6500-4517',
        '010-6602-1939',
        '010-6603-2720',
        '010-6615-4517',
        '010-6778-8547',
        '010-8493-1120',
        '010-8643-8790',
        '010-8974-1831',
        '010-9141-6649',
        '010-9438-2119',
        '010-9542-0770',
        '010-9554-3652',
        '010-9759-5120',
        '010-9836-0312',
        '010-9860-8020',
        '010-9981-1831',
        '010-6593-9004',
        '010-4698-2502',
        '010-5618-8361',
        '010-4648-1077',
        '010-9742-0979',
        '010-8368-8361',
        '010-2572-8361',
        '010-9617-8361',
        '010-2502-8361',
        '010-2101-9989',
        '010-3240-0662',
        '010-3676-0662',
        '010-7124-0662',
        '010-9831-2488',
        '010-4477-6123',
        '010-4854-6163',
        '010-5211-6163',
        '010-5213-6163',
        '010-5658-6163',
        '010-2338-5172',
        '010-3035-5428',
        '010-2264-6163',
        '010-2449-4463',
        '010-2450-4463',
        '010-2475-4463',
        '010-5658-4463',
        '010-6405-4463',
        '010-6474-9943',
        '010-6704-1100',
        '010-9792-2488',
        '010-2863-4691',
        '010-9386-5120',
        '010-5028-3845',
        '010-2475-4463',
        '010-4477-6123',
        '010-5106-7717',
        '010-2859-9711',
        '010-3029-3652',
        '010-2450-4463',
        '010-9999-9999'
      ]
    }
  },
  watch: {
    giftData () {
      if (!this.load) {
        // 페이지 로딩시 방문소감 작성해야 되는 선물 있을때
        if (this.mingleCode === 'ClJDKcCIq5mBFLdPmkYwPQ==' || this.mingleCode === 'eQrgky8nqusaT5/PVbxMjw==' || this.mingleCode === 'ht9zN2+0aQ1KGqd3vlQn0g==') {
          var giftIdx = 0
          for (giftIdx; giftIdx < this.giftData.length; giftIdx++) {
            if (this.$route.query.impression !== 'y' && this.giftData[giftIdx].mingle_gift_receive === 'Y' && this.giftData[giftIdx].mingle_comment_no === '') {
              this.$store.state.impressionOpen = true
              this.$store.state.imporessionGiftCode = this.giftData[giftIdx].mingle_user_gift_no
              break
            }
          }
          this.giftData.map((v, idx) => {
            if (idx === giftIdx) {
              localStorage.impressionData = JSON.stringify(v)
            }
          })
        }
      }
    },
    stampCodeInfo () {
      this.setStamp()
    }
  },
  computed: {
    ...mapState(['giftData', 'stampCodeInfo', 'mingleCode', 'blackListPop', 'okhwaCnt', 'okhwaYn', 'starPointPop'])
  },
  methods: {
    // 점 표시
    dotOn (data) {
      let dot = ''
      if (data.mingle_gift_receive === 'Y') {
        dot = 'on'
      } else if (data.mingle_gift_receive === 'N' && data.mingle_gift_end_date !== '0000-00-00 00:00:00') {
        dot = 'end'
      }
      return dot
    },
    // 선물 아이콘 on/off
    giftOn (data) {
      let img = ''
      if (data.mingle_gift_receive === 'Y') {
        img = 'icon_gift'
      } else {
        img = 'icon_gift_off'
      }
      return require(`@/assets/images/${img}.png`)
    },
    giftReceive (data) {
      console.log(data.star_point_popup)
      let flag = false
      this.blackList.map((val) => {
        if (data.member_mobile === val) {
          this.$store.state.blackListPop = true
          flag = true
        }
      })
      if (data.mingle_gift_receive === 'Y' && !flag) {
        if (this.mingleCode === 'ClJDKcCIq5mBFLdPmkYwPQ==' || this.mingleCode === 'eQrgky8nqusaT5/PVbxMjw==' || this.mingleCode === 'ht9zN2+0aQ1KGqd3vlQn0g==') { // 경기서부 7길
          if (data.mingle_comment_no === '') { // 방문소감을 안 썼음
            // 방문소감 링크 팝업 팝업 띄우기
            this.$store.state.impressionOpen = true
            this.$store.state.imporessionGiftCode = data.mingle_user_gift_no
            localStorage.impressionData = JSON.stringify(data)
          } else { // 방문소감을 썼음
            this.$store.dispatch('openPopupGift', data)
          }
        } else {
          if (data.star_point_popup === 'Y' && !this.$cookie.get('writeStarPoint')) {
            // 별점 팝업
            this.$store.state.starPointPop = true
          } else {
            this.$store.dispatch('openPopupGift', data)
          }
        }
      }
    },
    setStamp () {
      this.stampCodeInfo.map((data) => {
        if (data.code === this.mingleCode && data.info === 'point') {
          this.unit = 'P'
        } else if (data.code === this.mingleCode && data.info === 'number') {
          this.unit = '개'
        }
      })
    },
    dDay (data) {
      const text1 = data.mingle_gift_end_date.split(' ')[0].split('-')
      const text2 = data.mingle_gift_end_date.split(' ')[1].split(':')
      const Dday = new Date(
        parseInt(text1[0]),
        parseInt(text1[1]) - 1, // 월 -1
        parseInt(text1[2]),
        parseInt(text2[0]),
        parseInt(text2[1]),
        parseInt(text2[2])
      )
      const now = new Date()
      const gap = now.getTime() - Dday.getTime()
      let text = ''
      let result = 0
      result = Math.floor(gap / (1000 * 60 * 60 * 24)) * -1
      if (result > 1) {
        text = `${result}일전`
      } else {
        result = Math.floor(gap / (1000 * 60 * 60)) * -1
        if (result > 1) {
          text = `${result}시간전`
        } else {
          result = Math.floor(gap / (1000 * 60)) * -1
          if (result > 1) {
            text = `${result}분전`
          } else {
            text = ''
          }
        }
      }
      if (!data.mingle_gift_add_point) {
        return `신청 유효 기간 만료 ${text}`
      } else {
        if (data.mingle_gift_end_date !== '0000-00-00 00:00:00' && data.mingle_gift_receive === 'N' && data.mingle_no === '1') {
          return '인증서 신청 완료'
        } else {
          return ''
        }
      }
    },
    cntCheck (data) {
      let cnt = 0
      if (data.mingle_no === '43' && data.mingle_gift_add_point) {
        cnt = this.okhwaCnt
      } else {
        cnt = data.user_com_cnt
      }
      return cnt
    },
    // 임시 마감 처리...(고도화 필요)
    giftEndState (data) {
      let status = false
      if (
        (data.mingle_no === '48' && (data.mingle_gift_order === '3' || data.mingle_gift_order === '4' || data.mingle_gift_order === '5')) ||
        (data.mingle_no === '55' && data.mingle_gift_order === '6')
      ) {
        status = true
      }
      return status
    }
  },
  mounted () {
    // 청주스탬프투어는 동의 항상 받기
    if (this.mingleCode === 'ht9zN2+0aQ1KGqd3vlQn0g==') {
      this.$cookie.set('agree_security', 'N', 9999)
    }
    if (localStorage.giftopen) {
      this.$store.dispatch('openPopupGift', JSON.parse(localStorage.giftopen))
      localStorage.removeItem('giftopen')
    }
    // 경기서부 7길
    if (this.mingleCode === 'ClJDKcCIq5mBFLdPmkYwPQ==' || this.mingleCode === 'eQrgky8nqusaT5/PVbxMjw==' || this.mingleCode === 'ht9zN2+0aQ1KGqd3vlQn0g==') {
      if (!this.$route.query.impression) {
        localStorage.removeItem('impressionData')
      }
      // 방문소감 작성 완료후 돌아오자마자 선물 받기 팝업
      if (this.$route.query && localStorage.impressionData) {
        this.$store.dispatch('openPopupGift', JSON.parse(localStorage.impressionData))
        localStorage.removeItem('impressionData')
      }
    }
    this.setStamp()
  }
}
</script>
